import React from 'react';
import { Table, Button, DropdownButton, MenuItem } from 'react-bootstrap';
import { getUser, toProperCase } from '../../utils/Common';
import { getAccessLevelClass } from './utils';

export default function UserTable({ 
  users, 
  caps, 
  userCaps, 
  currentUser, 
  isMobile, 
  handleAccessChange, 
  getReadableAccessLevel,
  history
}) {
  const handleUserClick = (userId) => {
    const user = users.find(u => u.userId === userId);
    if(user.builderId) {
      history.push(`/accesscontrol/${user.builderId}/user/${userId}`);
    } else {
      console.log('No builderId found for user', user);
    }
  };

  return (
    <div className="access-control-table-scroll access-control-employee-matrix">
      <Table bordered condensed striped hover className="cap-access-table">
        <thead>
          <tr>
            <th className="sticky-left access-control-employee-col">Employee</th>
            {caps.map(cap => {
              const currentUserCap = userCaps.find(
                uc => uc.userId === currentUser.userId && uc.capId === cap.capId
              );
              const hasAccess = currentUserCap && currentUserCap.accessType === 'OWNER';
              return (
                <th key={cap.capId+'-header'} className="cap-name-cell" style={{
                  opacity: hasAccess ? 1 : 0.5,
                  backgroundColor: hasAccess ? 'inherit' : '#f8f9fa',
                  verticalAlign: 'middle',
                }}>
                  <Button
                    bsStyle="default"
                    onClick={() => window.location.href = `/caps/${cap.capId}`}
                    className="cap-name-button access-control-cap-link"
                  >
                    {cap.name}
                  </Button>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {users
            .sort((a, b) => {
              if (a.userId === currentUser.userId) return -1;
              if (b.userId === currentUser.userId) return 1;
              return a.email < b.email ? -1 : 1;
            })
            .map(user => (
              <tr
                key={user.userId}
                className={user.userId === currentUser.userId ? 'access-control-employee-row--current' : undefined}
              >
                <td className="sticky-left access-control-employee-col">
                  <Button
                    bsStyle="default"
                    onClick={() => handleUserClick(user.userId)}
                    className={`access-control-employee-btn ${user.role === 'SHARE_CREATE' ? 'warning' : ''} ${user.userId === currentUser.userId ? 'access-control-employee-btn--current' : ''}`}
                  >
                    {user.role === 'SHARE_CREATE' && (
                      <i className="fas fa-exclamation-circle" />
                    )}
                    {user.firstName ? (user.lastName ? toProperCase(user.firstName) + " " + toProperCase(user.lastName) : toProperCase(user.firstName)) : user.email}
                  </Button>
                </td>
                {caps.map(cap => {
                  const userCap = userCaps.find(
                    uc => uc.userId === user.userId && uc.capId === cap.capId
                  );
                  const currentUserCap = userCaps.find(
                    uc => uc.userId === currentUser.userId && uc.capId === cap.capId
                  );
                  const accessLevel = userCap ? userCap.accessType : 'No Access';
                  const isCurrentUser = user.userId === currentUser.userId;
                  const hasAccess = currentUserCap && currentUserCap.accessType === 'OWNER';
                  const tierClass = getAccessLevelClass(accessLevel, user);
                  
                  return (
                    <td key={cap.capId} className={`cap-access-cell ${tierClass}`} style={{
                      opacity: hasAccess ? 1 : 0.65,
                    }}>
                      <DropdownButton
                        title={getReadableAccessLevel(accessLevel, user, isMobile)}
                        id={`dropdown-${user.userId}-${cap.capId}`}
                        className={`access-tier-dropdown ${tierClass}`}
                        onSelect={(newType) => handleAccessChange(user.userId, cap.capId, newType)}
                        disabled={isCurrentUser || !hasAccess}
                        bsSize={isMobile ? "xs" : "small"}
                      >
                        <MenuItem eventKey="No Access" className="access-tier--none">{getReadableAccessLevel('No Access', user, isMobile)}</MenuItem>
                        <MenuItem eventKey="DEMO" className="access-tier--demo">{getReadableAccessLevel('DEMO', user, isMobile)}</MenuItem>
                        <MenuItem eventKey="VIEWER" className="access-tier--viewer">{getReadableAccessLevel('VIEWER', user, isMobile)}</MenuItem>
                        <MenuItem eventKey="OWNER" className="access-tier--owner">{getReadableAccessLevel('OWNER', user, isMobile)}</MenuItem>
                        {getUser().role==='ADMIN' && <MenuItem eventKey="SALES_DEMO" className="access-tier--sales-demo">{getReadableAccessLevel('SALES_DEMO', user, isMobile)}</MenuItem>}
                      </DropdownButton>
                    </td>
                  );
                })}
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
} 